"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductInfoFilter_1 = require("../model/ProductInfoFilter");

var ProductInfoFilterConverter_1 = require("./ProductInfoFilterConverter");
/**
 * Implementation of {@link ProductInfoFilterConverter}.
 *
 * @author Radek Beran
 */


var ProductInfoFilterConverterImpl =
/*#__PURE__*/
function (_ProductInfoFilterCon) {
  _inherits(ProductInfoFilterConverterImpl, _ProductInfoFilterCon);

  function ProductInfoFilterConverterImpl() {
    _classCallCheck(this, ProductInfoFilterConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductInfoFilterConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(ProductInfoFilterConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ProductInfoFilter_1.ProductInfoFilter(source.textForSearch, source.categoryId);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        textForSearch: source.textForSearch,
        categoryId: source.categoryId
      };
    }
  }]);

  return ProductInfoFilterConverterImpl;
}(ProductInfoFilterConverter_1.ProductInfoFilterConverter);

exports.ProductInfoFilterConverterImpl = ProductInfoFilterConverterImpl;